// Função para formatar a data no formato dd/MM/yyyy
export default function formatDateBr(data: Date) {
  var dateTime = new Date(data);
  dateTime.setHours(dateTime.getHours() - 9);

  var day = dateTime.getDate();
  var month = dateTime.getMonth() + 1; 
  var year = dateTime.getFullYear();

  var hour = dateTime.getHours();
  var minutes = dateTime.getMinutes();

  var formattedDay = (day < 10) ? '0' + day : day.toString();
  var formattedMonth = (month < 10) ? '0' + month : month.toString();
  var formattedHour = (hour < 10) ? '0' + hour : hour.toString();
  var formattedMinutes = (minutes < 10) ? '0' + minutes : minutes.toString();

  var formattedDateTime = formattedDay + '/' + formattedMonth + '/' + year + ' ' + formattedHour + ':' + formattedMinutes;

  return formattedDateTime;
}
